export const RestDefaultHeaders = {
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache, no-store',
};
